export default __webpack_public_path__ + "static/media/translations.708b7ac1.csv";